module.exports = __webpack_public_path__ + "63098325a566da35192858c94d98d17a.svg";